import { Input } from "antd-mobile";
import styles from "./style.module.scss";

const FilterTypeInput = ({ title = "", placeholder = "", value = "", setValue = () => {} }) => {
  const onTextChange = (e) => {
    setValue(e);
  };
  return (
    <div className={`${styles.container}`}>
      <div className={`${styles.title}`}>{title}</div>
      <Input
        className={`${styles.input}`}
        value={value}
        onChange={onTextChange}
        placeholder={placeholder}
      />
    </div>
  );
};

export default FilterTypeInput;
